/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CloseIcon({
  children,
  viewPath = "/DesignSystem/Svgs/CloseIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="CloseIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-1MQF6h': alignSelf,'--mt-2-1MQF6h': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1MQF6h': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1MQF6h': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1MQF6h': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1MQF6h': opacity,'--w-10-1MQF6h': typeof width === 'number' ? `${width}px` : width,'--h-11-1MQF6h': typeof height === 'number' ? `${height}px` : height,'--a-7-1MQF6h': isAnimated ? animation : "none",'--sd-8-1MQF6h': isAnimated ? strokeDashoffset : 0,'--sd-9-1MQF6h': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="CloseIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 d="M26.4 5.6L5.6 26.4M26.4 26.4L5.6 5.6"
 style={{'--f-12-1MQF6h': fill,'--s-13-1MQF6h': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}